import { Routes } from "./constants";

export interface AdminNavItem {
    name: string;
    route?: Routes | string;
    isComingSoon?: boolean;
    superAdminOnly?: boolean;
}

export interface AdminNavSection {
    title?: string;
    items: AdminNavItem[];
}

export const ADMIN_NAV_SECTIONS: AdminNavSection[] = [
    {
        items: [
            { name: 'Dashboard', route: Routes.ADMIN_ANALYTICS }
        ]
    },
    {
        title: 'Content Management',
        items: [
            { name: 'Videos', route: Routes.ADMIN_VIDEOS },
            { name: 'Highlights', route: Routes.ADMIN_HIGHLIGHTS },
            { name: 'Collections', route: Routes.ADMIN_COLLECTIONS },
            { name: 'Promos', route: Routes.ADMIN_PROMOS },
            { name: 'Images', route: Routes.ADMIN_IMAGES }
        ]
    },
    {
        title: 'Data',
        items: [
            { name: 'Events', route: Routes.ADMIN_EVENTS },
            { name: 'Video Types', route: Routes.ADMIN_EVENT_TYPES },
            { name: 'Venues', route: Routes.ADMIN_LOCATIONS },
            { name: 'Participants', route: Routes.ADMIN_PARTICIPANTS },
            { name: 'Participant Attributes', route: Routes.ADMIN_PARTICIPANT_ATTRIBUTES },
            { name: 'Participant Attribute Values', route: Routes.ADMIN_PARTICIPANT_ATTRIBUTE_VALUES },
            { name: 'Video Participant Types', route: Routes.ADMIN_VIDEO_PARTICIPANT_TYPES },
            { name: 'Video Participants', route: Routes.ADMIN_VIDEO_PARTICIPANTS }
        ]
    },
    {
        title: 'Admin',
        items: [
            { name: 'Payment Operations', route: Routes.ADMIN_PAYMENT_OPERATIONS },
            { name: 'Payment Disputes', route: Routes.ADMIN_PAYMENT_DISPUTES },
            { name: 'Email Logs', route: Routes.ADMIN_EMAIL_LOGS },
            { name: 'Users', route: Routes.ADMIN_USERS },
            { name: 'Site Configuration', route: Routes.ADMIN_SITE_CONFIGURATION }
        ]
    },
    {
        title: 'Super Admin',
        items: [
            { name: 'Video Analytics', route: Routes.ADMIN_VIDEO_ANALYTICS, superAdminOnly: true },
            { name: 'Video Playback', route: Routes.ADMIN_VIDEO_PLAYBACK, superAdminOnly: true },
            { name: 'Diagnostics', route: Routes.ADMIN_DIAGNOSTICS, superAdminOnly: true },
            { name: 'Storage Browser', route: Routes.ADMIN_STORAGE, superAdminOnly: true },
            { name: 'Content Processing Config', route: Routes.ADMIN_CONTENT_PROCESSING_CONFIG, superAdminOnly: true },
            { name: 'Content Processing Activity', route: Routes.ADMIN_CONTENT_PROCESSING_ACTIVITY, superAdminOnly: true }
        ]
    }
];

export const ADMIN_NAV_ITEMS: AdminNavItem[] = ADMIN_NAV_SECTIONS.flatMap((section) => section.items);
export const ADMIN_NAV_ACTION_ITEMS: AdminNavItem[] = ADMIN_NAV_ITEMS.filter((item) => Boolean(item.route));
